import React, { useEffect, useState } from "react";
import Card from "../../components/Card";
import Dropdown from "../../components/Dropdown";
import ImageInput from "../../components/ImageInput";
import TextInput from "../../components/TextInput";
import { InputController } from "../../hooks/input-controller";
import { UseApi } from "../../hooks/use-api";
import { ToastEmitter } from "../../Services/assets/toast-emitter";
import styles from "./Banner.module.sass";
import cn from "classnames";
import Loader from "../../components/Loader";
import { EditBanner as edit } from "../../Services/lib/admin";
import { GetProduct } from "../../Services/lib/nft";
import SearchProduct from "./searchProduct";
import { useUser } from "../../context";
import banner from "../../i11/Banner";

const type = ["big", "medium"];
const linksTo1 = ["Community marketplace", "Token Store", "Product"];
const linksTo2 = ["-", "Collections", "Categories"];
const dic1 = {
	marketplace: "Community marketplace",
	collections: "Token Store",
	categories: "Token Store",
	template: "Product",
};

function capitalizeFirstLetter(string) {
	return string.charAt(0).toUpperCase() + string.slice(1);
}

const EditBanner = ({ initial, onClose, linksTo3 }) => {
	const { locale } = useUser();
	const [{ isLoading }, create] = UseApi({
		service: edit,
	});
	const [{ isLoading: initLoad }, getProd] = UseApi({
		service: GetProduct,
	});
	const [Type, setType] = useState(initial.banner_size);
	const [link1, setLink1] = useState(linksTo1[0]);
	const [link2, setLink2] = useState(linksTo2[0]);
	const [link3, setLink3] = useState(linksTo3[linksTo2[0]]?.vals[0] || "");

	const [val, setVal] = useState({
		name: "",
		_id: "",
	});

	const initVal = async (_id) => {
		const res = await getProd(_id);
		if (res) {
			setVal({
				name: res.name,
				_id: res._id,
			});
		}
	};

	useEffect(() => {
		const urlArr = initial.url.split("/");
		console.log(urlArr);
		if (urlArr.length === 2) {
			setLink1(dic1[urlArr[1]]);
			setLink2(linksTo2[0]);
		} else if (urlArr[1] === "template") {
			setLink1(dic1[urlArr[1]]);
			initVal(urlArr[2]);
		} else {
			setLink1(dic1[urlArr[1]]);
			setLink2(capitalizeFirstLetter(urlArr[1]));
			setLink3(urlArr[2]);
		}
	}, []);

	const [body, setBody] = useState(initial);

	const [imgL, setL] = useState(false);

	const onSubmit = async (e) => {
		e.preventDefault();
		if (imgL) {
			ToastEmitter({
				msg: "Image is uploading, please wait",
				type: "info",
			});
		} else {
			const tmp = { ...body };
			if (tmp.image.image_list) {
				tmp.image_thumb = tmp.image.image_list;
				tmp.image = tmp.image.core_image_url;
			}
			tmp.banner_size = Type;
			if (link1 === "Community marketplace") {
				tmp.url = "/marketplace";
			} else if (link1 === "Product") {
				tmp.url = `/template/${val._id}`;
			} else if (link2 === "-") {
				tmp.url = "/collections";
			} else {
				tmp.url = `/${link2.toLowerCase()}/${link3}`;
			}
			const res = await create(tmp);
			if (res) {
				onClose();
				ToastEmitter({
					type: "success",
					msg: "Successfully edit a banner.",
				});
			}
		}
	};

	const title = InputController("title", setBody);
	const prior = InputController("prior", setBody);

	const HandleChange = (e) => {
		setBody((p) => {
			return {
				...p,
				image: e,
			};
		});
	};

	return (
		<form onSubmit={onSubmit} className={styles.form}>
			<TextInput
				defaultValue={initial.title}
				className={styles.field}
				label={banner[locale].banner_text}
				name="title"
				type="text"
				// tooltip={banner[locale].banner_text_tooltip}
				required
				{...title}
			/>
			<Dropdown
				className={cn(styles.field, styles.Dropdown)}
				label={banner[locale].size}
				// tooltip={banner[locale].size_tooltip}
				value={Type}
				setValue={setType}
				options={type}
				dictionary={banner[locale].typeDic1}
			/>
			<ImageInput
				where="BANNERS"
				aspect_ratio={Type === type[0] ? 135 / 43 : 135 / 86}
				callBack={HandleChange}
				initial={initial.image}
				className={styles.field}
				label={banner[locale].banner_image}
				required
				tooltip={banner[locale].banner_image_tooltip}
				setL={setL}
			/>
			<div className={styles.multiDropDown}>
				<Dropdown
					className={cn(styles.field, styles.Dropdown)}
					label={banner[locale].links_to}
					tooltip={banner[locale].links_to_tooltip}
					value={link1}
					setValue={setLink1}
					dictionary={banner[locale].linksTo1Dic}
					options={linksTo1}
				/>
				{link1 === "Product" && (
					<SearchProduct val={val} setVal={setVal} initLoad={initLoad} />
				)}
				{link1 === "Token Store" && (
					<Dropdown
						className={cn(styles.field, styles.Dropdown)}
						value={link2}
						setValue={(e) => {
							setLink2(e);
							setLink3(linksTo3[e]?.vals[0] || "");
						}}
						dictionary={banner[locale].linksTo2Dic}
						options={linksTo2}
					/>
				)}
			</div>
			{link1 === "Token Store" && link2 !== "-" && (
				<Dropdown
					className={cn(styles.field, styles.Dropdown)}
					value={link3}
					setValue={setLink3}
					options={linksTo3[link2]?.vals}
					dictionary={linksTo3[link2]?.dic}
				/>
			)}
			<TextInput
				defaultValue={initial.prior}
				className={styles.field}
				label={banner[locale].order}
				name="Priority"
				type="number"
				tooltip={banner[locale].order_tooltip}
				required
				{...prior}
			/>

			<div className={styles.field}>
				<button className={cn("button", { disabled: isLoading })}>
					{isLoading && <Loader />}
					{banner[locale].save}
				</button>
			</div>
		</form>
	);
};

export default EditBanner;
